$('button[data-pdfmodal]').each(function () {
    let $this = $(this);
    let $pdfModal = $this.closest('section').find('dialog');
    let thisEmbeddUrl = $this.attr('data-pdfmodal');
    $this.click(function (e) {
        $pdfModal.find('iframe').attr('src', thisEmbeddUrl);
        $pdfModal[0].showModal();
    });
});
